module.exports = __webpack_public_path__ + "OpenSans-Light.4dfa927030dec6d0ca8f.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Light.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-Light.eot
// module chunks = styles